/**
 * Instagram Platform Media Restrictions
 * Based on official Instagram Graph API specifications
 *
 * @see https://developers.facebook.com/docs/instagram-api/reference/ig-user/media
 */

export const INSTAGRAM_RESTRICTIONS = {
  image: {
    maxFileSize: 8 * 1024 * 1024, // 8 MB
    allowedFormats: ['image/jpeg', 'image/jpg', 'image/png'],
    minResolution: { width: 320, height: 320 },
    maxResolution: { width: 1440, height: 1440 },
    aspectRatio: {
      min: 0.8, // 4:5
      max: 1.91, // 1.91:1
    },
  },
  video: {
    maxFileSize: 100 * 1024 * 1024, // 100 MB
    allowedFormats: ['video/mp4', 'video/mov'],
    minDuration: 3, // seconds
    maxDuration: 60, // seconds (Reels)
    minResolution: { width: 720, height: 720 },
    aspectRatio: {
      min: 0.01,
      max: 10,
    },
    frameRate: {
      min: 23,
      max: 60,
    },
  },
  carousel: {
    maxItems: 10, // Max items per carousel
    allowedTypes: ['image', 'video'], // Can mix images and videos
  },
  story: {
    image: {
      maxFileSize: 8 * 1024 * 1024,
      allowedFormats: ['image/jpeg', 'image/jpg', 'image/png'],
      recommendedAspectRatio: 9 / 16, // 9:16 vertical
    },
    video: {
      maxFileSize: 100 * 1024 * 1024,
      allowedFormats: ['video/mp4', 'video/mov'],
      maxDuration: 15, // seconds
      recommendedAspectRatio: 9 / 16, // 9:16 vertical
    },
  },
  caption: {
    maxLength: 2200, // characters
    // Instagram capped hashtags at 5 per post/reel in December 2025; counted across caption + comments combined.
    maxHashtags: 5,
  },
  general: {
    // Instagram doesn't support document uploads
    supportsDocuments: false,
    requiresMedia: true, // Posts must have at least one media file
  },
} as const

export type InstagramRestrictions = typeof INSTAGRAM_RESTRICTIONS
